import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export const apiClient = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

let unauthorizedHandler = null;
let refreshTokenProvider = null; // () => string | null
let tokensUpdatedHandler = null; // ({ accessToken, refreshToken }) => void

/** Регистрируется из AuthContext: при неудачном refresh сбрасывает сессию. */
export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = handler;
}

/** Источник актуального refresh-токена (из AuthContext/localStorage). */
export function setRefreshTokenProvider(provider) {
  refreshTokenProvider = provider;
}

/** Колбэк, куда отдаём обновлённую пару токенов после refresh. */
export function setTokensUpdatedHandler(handler) {
  tokensUpdatedHandler = handler;
}

export function setApiAuthToken(token) {
  if (token) {
    apiClient.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete apiClient.defaults.headers.common.Authorization;
  }
}

// Одновременный refresh: держим единственный промис, остальные ждут его.
let refreshPromise = null;

async function performRefresh() {
  const refreshToken = refreshTokenProvider ? refreshTokenProvider() : null;
  if (!refreshToken) return null;
  try {
    // Отдельный axios, чтобы не попасть в собственный интерсептор.
    const resp = await axios.post(`${API_BASE}/auth/refresh`, {
      refresh_token: refreshToken,
    });
    const accessToken = resp.data?.access_token || null;
    const newRefresh = resp.data?.refresh_token || null;
    if (accessToken && tokensUpdatedHandler) {
      tokensUpdatedHandler({ accessToken, refreshToken: newRefresh });
    }
    return accessToken;
  } catch (_) {
    return null;
  }
}

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    const isRefreshCall = original.url && original.url.includes('/auth/refresh');

    if (status === 401 && !original._retried && !isRefreshCall) {
      original._retried = true;
      if (!refreshPromise) {
        refreshPromise = performRefresh().finally(() => {
          refreshPromise = null;
        });
      }
      const newAccess = await refreshPromise;
      if (newAccess) {
        original.headers = original.headers || {};
        original.headers.Authorization = `Bearer ${newAccess}`;
        return apiClient(original);
      }
      if (unauthorizedHandler) unauthorizedHandler();
    }
    return Promise.reject(error);
  }
);

export function getApiBaseUrl() {
  return API_BASE;
}

/** Путь к прокси изображений (вне baseURL /api при необходимости). */
export function apiUrl(path) {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE}${p}`;
}
